import React from 'react';
import PropTypes from "prop-types";
import FieldFormula from "../formula";

// export default function FieldFormula_View(props:FieldViewProps) {
//
//     const value = _.get(props.model, props.field.fieldId, null)
//
//     const classes = Classes("ui5-txt-default", "txt-truncate", props.className, {
//         'invalid-value': !props.field.isValueValid(value)
//     })
//
//     return (
//         <div className={classes}>
//             {!_.isNil(value) && _.get(props.field.components, 'ValuePrefix', false)}
//             {props.field.getDisplayValue(value)}
//         </div>
//     );
// }

type FieldFormulaViewProps = {
    field       : FieldFormula
    model       : any;
    className?  : string;
    options?    : any
    onClick?    : onClick
};


export default class FieldFormula_View extends React.Component<FieldFormulaViewProps, any> {

    static propTypes = {
        field: PropTypes.object,
        value: PropTypes.any,
    }

    constructor(props:FieldFormulaViewProps) {
        super(props);

        this.state = {
            showPopover: false,
        }
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    render() {

        const value = this.props.field.calculateValue(this.props.model)
        const classes = Classes("ui5-txt-default", "txt-truncate", this.props.className, {
            'invalid-value': !this.props.field.isValueValid(value),
            'show-popover' : this.state.showPopover,
        })

        return (
            <div className={classes} onClick={this.showPopover}>
                {this.props.field.getDisplayValue(value)}
                {this.state.showPopover && <this.props.field.components.PopoverMenu {...this.props} parent={this} />}
            </div>
        );
    }
}
